import { render, staticRenderFns } from "./MFQuickActionsBar.vue?vue&type=template&id=60b25494"
import script from "./MFQuickActionsBar.vue?vue&type=script&lang=js"
export * from "./MFQuickActionsBar.vue?vue&type=script&lang=js"
import style0 from "./MFQuickActionsBar.vue?vue&type=style&index=0&id=60b25494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports